import { useTranslation } from 'react-i18next';

import { SearchIcon } from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from './NoSearchResult.styles';

export const NoSearchResult = () => {
  const { t } = useTranslation();

  return (
    <S.Wrapper>
      <SearchIcon data-testid="searchIcon" height={30} width={30} />
      <S.TextWrapper>
        <Typography>{t('NoSearchResult.title')}</Typography>
        <S.Description>{t('NoSearchResult.description')}</S.Description>
      </S.TextWrapper>
    </S.Wrapper>
  );
};
